import axios from '@/libs/api.request'
// 添加评论
export const createComments = data => {
  return axios.request({
    url: '/comments/create',
    data,
    method: 'POST'
  })
}
// 获取评论列表
export const getCommentsPage = data => {
  return axios.request({
    url: '/comments/page',
    data,
    method: 'POST'
  })
}
